/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ChangeRequest({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" {...props}><circle cx={2} cy={2} r={2} stroke="CURRENTCOLOR" strokeWidth={1.2} transform="matrix(1 0 0 -1 1.097 5.75)" /><circle cx={2} cy={2} r={2} stroke="CURRENTCOLOR" strokeWidth={1.2} transform="matrix(1 0 0 -1 1.097 15.25)" /><path stroke="CURRENTCOLOR" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M3.097 5.75v5.5M9.722 4.688l2.59-2.375 2.592 2.375" /><path stroke="CURRENTCOLOR" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M5.097 13.25h5.55c.92 0 1.667-.746 1.667-1.667V2.99" /></svg>;
}
;